import {Component} from '@angular/core';
import {WidgetBaseComponent} from '../widget-base/widget-base.component';
import {DoraProperty, DoraPropertyArray} from '../../Decorators/Decorator';
import {_TRANSLATE} from '../../TranslationMarkers/TranslationMarkers';
import {LabelLink} from './data/label-link';
import {MessageGridSelected} from '../../messages/message-grid-selected';
import {MessageRowsSelected} from '../../messages/message-rows-selected';

@Component({
  selector: 'dora-label',
  templateUrl: './dora-label.component.html',
  styleUrls: ['./dora-label.component.scss']
})
export class DoraLabelComponent extends WidgetBaseComponent {
    @DoraProperty
    textId = _TRANSLATE('label_text');
    text = '';

    @DoraPropertyArray (LabelLink)
    labelLinks: LabelLink[] = [];

    // labelLink to use (correct locale)
    labelLink: LabelLink;


    onParameterInjectedFinished(): void {
    super.onParameterInjectedFinished();

    this.text = this.translationService.get(this.textId);

    // select LabelLink depending on language
    this.labelLink = this.labelLinks.find(labelLink => labelLink.language === this.locale);

    if (this.labelLink !== undefined) {
        // manage links

        // GRID
        this.messageService.getMessage(this.EventChannel, MessageGridSelected, this.CallerName).subscribe(doraMessage => {
            this.labelLink.setPlaceholder('[GRID]', (doraMessage.data as MessageGridSelected).idGrid);
        });

        // ROWS
        this.messageService.getMessage(this.EventChannel, MessageRowsSelected, this.CallerName).subscribe(doraMessage => {
            let flFirst = true;
            let value = '';
            (doraMessage.data as MessageRowsSelected).DataRows.forEach(dataRow => {
                if (flFirst) {
                    flFirst = false;
                } else {
                    value += '%2f%2f';
                }
                value += dataRow.Id;
            });
            this.labelLink.setPlaceholder('[ROWS]', value);
        });
    }
  }

    public getClass(): string {
        let cssClass = 'text-container';
        if (this.labelLink !== undefined) {
            cssClass += ' link';
        }

        return cssClass;
    }

    public onClick(): void {
        if (this.labelLink !== undefined) {
            window.open(this.labelLink.link, '_blank');
        }
    }
}

